import { Node as ProseMirrorNode } from "prosemirror-model";
import { NodeSelection } from "prosemirror-state";

import { hasOwnProperty } from "~/lib/js";

export function contentToJiraText(contents: ProseMirrorNode[]): string {
	return contents
		.map((content: ProseMirrorNode): string => {
			// @ts-ignore
			if (hasOwnProperty(content.content, "content") && content.content.content.length > 0) {
				// @ts-ignore
				return contentToJiraText(content.content.content);
			}
			if (content.type.name === "hard_break") {
				return " ";
			}
			return content?.text || "";
		})
		.join("");
}

export function selectionToJiraText(selection: NodeSelection) {
	// @ts-ignore
	return contentToJiraText(selection.node.content.content);
}
